module.exports = __webpack_public_path__ + "assets/images/a1a84254cf0aa09fd846930cd564a29a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/portfolio/kp-kiosk/kp-kiosk-0.jpg
// module id = 808
// module chunks = 0